import { gql } from '@apollo/client'

export const GetItems = gql`
  query GetItems(
    $limit: Int!
    $filter: GetItemFilterInput
    $nextToken: String
  ) {
    getItems(limit: $limit, filter: $filter, nextToken: $nextToken) {
      items {
        id
        name
        description
        price
        taxes {
          enabled
        }
      }
      nextToken
    }
  }
`
